import { Condition } from "@/pages/Cases/types/Cases.js";
import { httpDelete, httpGet, httpPost } from "../connection.js";

const query = async (query: {
  query: {
    case_id: string;
    page: number;
    pageSize: number;
    search?: string;
    order?: { field: "description"; sort: "asc" };
    conditions: Condition[];
    archive_id: number;
  };
}) => {
  return await httpPost("/cases/archives/query", query);
};

//Case Archive API
async function getCaseArchives(params = {}) {
  return await httpGet(`/cases/archives`, params);
}

async function createCaseArchive(params = {}) {
  return await httpPost(`/cases/archives`, params);
}

async function deleteCaseArchive(params: { archive_id: number }) {
  return await httpDelete(`/cases/archives/${params.archive_id}`);
}

// temp - will eventually be moved to a more global location
// my feature needed this but dont want to cross scope with FE typescript refactor.
interface MonolithQueryParams {
  pageSize?: number;
  page?: number;
  search?: string;
  order?: {
    field: string;
    sort: string;
  };
  case_id?: number;
  conditions?: Condition[];
}

interface ExportCaseArchivesListRequest {
  query: MonolithQueryParams;
  date_format: string;
  timezone: string;
  columns: {
    caption: string;
    dataField: string;
    dataType: string;
    format: { type: string };
    header: string;
  }[];
}

async function exportCaseArchiveList(query: ExportCaseArchivesListRequest) {
  return await httpPost("/cases/archives/export", query);
}

const CaseArchivesAPI = {
  query,
  getCaseArchives,
  createCaseArchive,
  deleteCaseArchive,
  exportCaseArchiveList,
};

export default CaseArchivesAPI;
